import { Button, Modal } from '@design-systems/canvas-ui'

// Asked before a document is deleted from the brand.
const DeleteDocumentModal = ({
  fileName = '',
  isDeleting = false,
  isOpen,
  onClose,
  onConfirm,
}) => {
  const footer = (
    <div className="publish-queue-modal__actions">
      <Button isDisabled={isDeleting} onClick={onClose} variant="secondary">
        Cancel
      </Button>
      <Button isLoading={isDeleting} onClick={onConfirm} variant="destructive">
        Delete
      </Button>
    </div>
  )

  return (
    <Modal
      footer={footer}
      headingText="Delete document"
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
    >
      <p>Do you want to delete {fileName}?</p>
    </Modal>
  )
}

export default DeleteDocumentModal
